import React, { Component } from "react";

import BlogItem from "components/BlogGrid/BlogItem";
import { I18n } from "react-i18next";
import i18n from "../../i18n";

export default class BlogGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      blogs: [],
      loading: true
    };
  }
  async componentDidMount() {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}fpgblog/v1/overview`
    );
    let blogs = await res.json();
    this.setState({ blogs: blogs });
  }

  renderBlog(blog, i) {
    return <BlogItem className="blogGrid-blogItem" data={blog} />;
  }

  renderBlogBig(blog, i) {
    return (
      <BlogItem
        className="blogGrid-blogItem blogGrid-blogItem__big"
        data={blog}
      />
    );
  }
  render() {
    const { blogs } = this.state;
    const s = 1;
    const b = 5;
    const currentState = this;

    return [
      <I18n>
        {(t, { i18n }) => (
          <div className="blogGrid">
            <div className="blogGrid-blogRow">
              {blogs.map(function(blog, i) {
                if (i === (s || b)) {
                  return currentState.renderBlogBig(blog, i);
                } else if (i === (s + 10 || b + 10)) {
                  return currentState.renderBlogBig(blog, i);
                } else {
                  return currentState.renderBlog(blog, i);
                }
              })}
            </div>
          </div>
        )}
      </I18n>
    ];
  }
}



// WEBPACK FOOTER //
// ./src/components/BlogGrid/BlogGrid.jsx